import { campInformation } from "../utils/CampInformation";
import { isRegistrationOpen } from "../utils/registration";

export default function ActionSection() {
  const camp = campInformation.wintercamp;

  return (
    <header className="hsyc-hero" id="action-section">
      <img
        className="hsyc-hero__photo"
        src="/full-camp-photo.jpeg"
        alt="Campers and counselors from a past winter camp gathered for a group photo"
      />
      <span className="hsyc-hero__flagpole" aria-hidden="true" />
      <div className="hsyc-wrap hsyc-hero__content">
        <div className="hsyc-hero__text">
          <h1>Houston Sikh Youth Camp</h1>
          <p className="hsyc-hero__theme">
            Winter 2026: <em>{camp.theme}</em>
          </p>
          <ul className="hsyc-hero__facts">
            <li>December 20 to 26, 2026</li>
            <li>YMCA Camp Cullen, Trinity, Texas</li>
            <li>Grades 1 through 12</li>
          </ul>
          {isRegistrationOpen() ? (
            <a className="hsyc-button" href={camp.registration_link}>
              Register for winter camp
            </a>
          ) : (
            <p className="hsyc-hero__closed">
              Registration for winter camp is closed.
            </p>
          )}
        </div>
      </div>
    </header>
  );
}
